export const createUserPageGuard = store => {
  return (to, from, next) => {
    if (store.getters.isSignedIn) {
      if (!store.state.currentUser.currentUser.profileComplete && to.path !== '/complete-profile') {
        next('/complete-profile')
        store.dispatch('app/loadingDone', {}, {root:true})
      } else if (store.state.currentUser.currentUser.passwordExpired && to.path !== '/update-password') {
        next('/update-password')
        store.dispatch('app/loadingDone', {}, {root:true})
      } else {
        next()
      }
    } else {
      next('/sign-in')
      store.dispatch('app/loadingDone', {}, {root:true})
    }
  }
}

export const createSignInPageGuard = store => {
  return (to, from, next) => {
    if (store.getters.isSignedIn) {
      next('/settings')
    } else {
      next()
    }
  }
}

export const createHomePageGuard = store => {
  return (to, from, next) => {
    if (store.getters.isSignedIn) {
      next('/stream')
      store.dispatch('app/loadingDone', {}, {root:true})
    } else {
      next()
    }
  }
}



// WEBPACK FOOTER //
// ./src/router/support.js